
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.193.586C.536.586 0 1.097 0 1.724c0 6.75 5.733 12.221 12.807 12.221.657 0 1.193-.51 1.193-1.138V10.39c0-.627-.536-1.138-1.193-1.138-.85 0-1.677-.13-2.443-.372a1.23 1.23 0 00-1.219.274l-1.352 1.29C6.059 9.53 4.622 8.162 3.668 6.51l1.354-1.292c.331-.316.426-.76.296-1.155l-.002-.006a7.115 7.115 0 01-.39-2.333c0-.627-.536-1.138-1.193-1.138h-2.54z","fill":"currentColor"}})])
          )
        }
      }
    